import type { Maybe, SearchResult } from '../../../../common/types';

const SearchResultLoomEntityPartial = `
... on SearchResultLoomFolder {
	lastModifiedDate
	loomId
	totalNestedVideos
	loomSpace: space {
		ari
		id
		name
	}
}
... on SearchResultLoomPlaylist {
	createdAt
	creatorAaid
	creatorName
	lastModifiedDate
	loomId
	thumbnailUrl
}
... on SearchResultLoomSpace {
	lastModifiedDate
	loomId
}
... on SearchResultLoomTag {
	count
	lastModifiedDate
}
`;

export interface SearchResultLoomSpaceSummary {
	ari: string;
	id: string;
	name: string;
}

export interface SearchResultLoomFolder extends SearchResult {
	__typename: 'SearchResultLoomFolder';
	lastModifiedDate?: Maybe<string>;
	loomId?: Maybe<string>;
	loomSpace?: Maybe<SearchResultLoomSpaceSummary>;
	totalNestedVideos?: Maybe<number>;
	type: 'folder';
}

export interface SearchResultLoomPlaylist extends SearchResult {
	__typename: 'SearchResultLoomPlaylist';
	createdAt?: Maybe<string>;
	creatorAaid?: Maybe<string>;
	creatorName?: Maybe<string>;
	lastModifiedDate?: Maybe<string>;
	loomId?: Maybe<string>;
	thumbnailUrl?: Maybe<string>;
	type: 'playlist';
}

export interface SearchResultLoomSpace extends SearchResult {
	__typename: 'SearchResultLoomSpace';
	lastModifiedDate?: Maybe<string>;
	loomId?: Maybe<string>;
	type: 'space';
}

export interface SearchResultLoomTag extends SearchResult {
	__typename: 'SearchResultLoomTag';
	count?: Maybe<number>;
	lastModifiedDate?: Maybe<string>;
	type: 'tag';
}

export type SearchResultLoomEntity =
	| SearchResultLoomFolder
	| SearchResultLoomPlaylist
	| SearchResultLoomSpace
	| SearchResultLoomTag;

export const isSearchResultLoomFolder = (
	partial: SearchResult,
): partial is SearchResultLoomFolder => partial.__typename === 'SearchResultLoomFolder';

export const isSearchResultLoomPlaylist = (
	partial: SearchResult,
): partial is SearchResultLoomPlaylist => partial.__typename === 'SearchResultLoomPlaylist';

export const isSearchResultLoomSpace = (partial: SearchResult): partial is SearchResultLoomSpace =>
	partial.__typename === 'SearchResultLoomSpace';

export const isSearchResultLoomTag = (partial: SearchResult): partial is SearchResultLoomTag =>
	partial.__typename === 'SearchResultLoomTag';

export const isSearchResultLoomEntity = (
	partial: SearchResult,
): partial is SearchResultLoomEntity =>
	isSearchResultLoomFolder(partial) ||
	isSearchResultLoomPlaylist(partial) ||
	isSearchResultLoomSpace(partial) ||
	isSearchResultLoomTag(partial);

export const getLoomEntityPartials = (): string => SearchResultLoomEntityPartial;
